import React from 'react';
import useV1Session from '@sls-react/hooks/useV1Session';
import useKnownCookie from '@sls-react/hooks/useKnownCookie';
import { FT_GEAR_EXPERT_CTA_MODE } from '../../constants/featureToggles';
import Head from 'next/head';
import getEnv from '@sls-react/utils/getEnv';
import { useSession } from '@sls-react/contexts/SessionContext';

const ZenDeskScript: React.FC = () => {
  const { loggedIn } = useSession();
  const { data: v1Session, isSuccess } = useV1Session();
  const [gearExpertsInitialized] = useKnownCookie('gexp_init');

  // If you're logged in, but we haven't determined your v1 session yet, don't do anything.
  if (loggedIn && !isSuccess) {
    return null;
  }

  if (v1Session?.user.power_seller) {
    const widgetSettings = {
      webWidget: {
        chat: {
          suppress: false,
          tags: ['vip'],
          notifications: {
            mobile: {
              disable: true,
            },
          },
        },
      },
    };

    return (
      <Head>
        <script
          type="text/javascript"
          id="zendesk-config"
          dangerouslySetInnerHTML={{
            __html: `
              window.zESettings = ${JSON.stringify(widgetSettings)};
            `,
          }}
        />

        <script
          id="ze-snippet"
          type="text/javascript"
          src="https://static.zdassets.com/ekr/snippet.js?key=fb735c1c-bdc2-4b89-a1d3-a197e621b157"
          async
        />
      </Head>
    );
  }

  if (FT_GEAR_EXPERT_CTA_MODE === 'zendesk') {
    // Don't suppress by default if you've initialized gear experts
    const suppress = gearExpertsInitialized !== '1';

    const newWidgetSettings = {
      webWidget: {
        launcher: {
          chatLabel: {
            '*': 'Gear Experts',
          },
          label: {
            '*': 'Gear Experts',
          },
        },
        chat: {
          suppress,
          hideWhenOffline: true,
        },
        contactForm: {
          suppress,
          title: {
            '*': 'Talk to an Expert',
          },
        },
        helpCenter: {
          suppress,
        },
        talk: {
          suppress,
        },
        answerBot: {
          suppress,
        },
      },
    };

    return (
      <Head>
        <script
          type="text/javascript"
          id="zendesk-config"
          dangerouslySetInnerHTML={{
            __html: `
              window.zESettings = ${JSON.stringify(newWidgetSettings)};
            `,
          }}
        />
        <script
          async
          id="ze-snippet"
          src="https://static.zdassets.com/ekr/snippet.js?key=36d2e927-8f17-487f-8a30-b2949f2d4c9d"
        />
      </Head>
    );
  }

  return null;
};

export default ZenDeskScript;
